import { useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { SharedButtonProps } from '~/eds/src/types/SharedButtonProps';
import { api } from '~/redux/api/createApi';
import { State as XRayState } from '~/redux/slices/x-ray/types';
import { Nullable } from '~/types/Nullable';

import { TargetEntityDetails } from '../../types/entity';
import { useLibraryModelDetailsModal } from './useLibraryModelDetailsModal';

interface Props extends SharedButtonProps {
  config: XRayState['configuration'];
  targetEntityDetails: Nullable<TargetEntityDetails>;
}

export const ManageLibraryModelDetailsTrigger = ({
  config,
  disabled,
  targetEntityDetails,
  tooltip,
}: Props) => {
  const intl = useIntl();
  const [saveLibraryModel, { data: libraryModel = null, isLoading: isSaving }] =
    api.endpoints.saveLibraryModel.useMutation();

  const [libraryModelDetailsModal, showLibraryModelDetailsModal] =
    useLibraryModelDetailsModal({
      config: libraryModel ? libraryModel.config : config,
      fieldName: targetEntityDetails?.label,
      isSaving,
      libraryModel,
      saveLibraryModel,
    });

  return (
    <>
      <Button
        disabled={disabled}
        tooltip={tooltip}
        isLoading={isSaving}
        text={
          isSaving
            ? intl.formatMessage({
                id: 'ManageLibraryModelDetailsTrigger.savingText',
                defaultMessage: 'Saving…',
                description: 'Button text when saving library model',
              })
            : libraryModel
              ? intl.formatMessage({
                  id: 'ManageLibraryModelDetailsTrigger.updateLibraryModelText',
                  defaultMessage: 'Update Library Model',
                  description:
                    'Button text for updating existing library model',
                })
              : intl.formatMessage({
                  id: 'ManageLibraryModelDetailsTrigger.saveLibraryModelText',
                  defaultMessage: 'Save Library Model',
                  description: 'Button text for saving new library model',
                })
        }
        onClick={showLibraryModelDetailsModal}
      />
      {libraryModelDetailsModal}
    </>
  );
};
